import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UG2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UG2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V19H22V4H2Z"
        fill="#FECA00"
      />
      <mask
        id="mask0_1813_1000"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_1000)">
        <rect x="2" y="4" width="20" height="2.5" fill="#272727" />
        <rect x="2" y="9" width="20" height="2.5" fill="#D74800" />
        <rect x="2" y="11.5" width="20" height="2.5" fill="#272727" />
        <rect x="2" y="16.5" width="20" height="2.5" fill="#D74800" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15.25C14.0711 15.25 15.75 13.5711 15.75 11.5C15.75 9.42893 14.0711 7.75 12 7.75C9.92893 7.75 8.25 9.42893 8.25 11.5C8.25 13.5711 9.92893 15.25 12 15.25Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5499 9.20546L9.88867 9.42243L10.5499 9.47904C10.5499 9.47904 10.6568 9.74051 10.5499 9.94463C10.5228 9.99644 10.4528 10.0628 10.3634 10.1476C10.1008 10.3966 9.67097 10.8042 9.67097 11.4665C9.67097 12.354 11.3838 12.7564 11.3838 12.7564V13.1781C11.3838 13.1781 11.5826 13.3016 10.4484 13.3016C9.4647 13.3016 9.52622 13.675 9.5599 13.8794C9.56506 13.9107 9.56956 13.938 9.56956 13.9595C9.56956 14.1209 10.0423 13.7981 10.2637 13.4767C10.3802 13.3075 10.868 13.3165 11.3687 13.3629C11.4082 13.3665 11.7733 14.1399 11.4564 14.5394C11.3232 14.7072 10.8634 14.7291 10.5761 14.7427C10.4297 14.7497 10.328 14.7545 10.3375 14.7755C10.3445 14.7912 10.4312 14.786 10.5571 14.7785C10.7143 14.7691 10.9326 14.7561 11.1339 14.7755C11.1644 14.7784 11.046 14.8812 10.9262 14.9852C10.8029 15.0922 10.6781 15.2005 10.7133 15.2022C10.7528 15.204 10.9838 15.0761 11.1936 14.9598C11.3672 14.8636 11.5264 14.7755 11.5507 14.7755C11.709 14.7755 11.852 14.795 11.9774 14.8122C12.187 14.8408 12.3475 14.8627 12.4486 14.7755C12.4797 14.7486 12.2993 14.7054 12.1153 14.6613C11.9258 14.6159 11.7325 14.5696 11.763 14.5394C11.9372 14.3665 11.8644 14.0041 11.8071 13.7187C11.7814 13.5906 11.7588 13.4781 11.763 13.4051C11.7779 13.1458 12.0521 13.2818 12.2676 13.3887C12.362 13.4355 12.4451 13.4767 12.4903 13.4767C12.8984 13.4767 12.3916 12.9605 12.1135 12.6772C12.0891 12.6524 12.0665 12.6293 12.0464 12.6086C11.9049 12.4625 12.0042 12.4821 12.2284 12.5265C12.3996 12.5603 12.6435 12.6086 12.9089 12.6086C13.522 12.6086 13.9695 12.4094 13.814 11.8701C13.7115 11.5143 13.1499 11.3932 12.5633 11.2667C12.2607 11.2015 11.9514 11.1348 11.695 11.0337C11.0641 10.785 11.0963 10.4225 11.1235 10.1159C11.1288 10.0563 11.1339 9.99877 11.1339 9.94463C11.1339 9.61212 11.695 9.20546 11.695 9.20546C11.695 9.20546 11.4389 8.77637 11.0143 8.77637C10.5896 8.77637 10.5499 9.20546 10.5499 9.20546ZM11.705 13.1103V12.7967C11.705 12.7967 11.9672 12.7881 12.0592 13.0087C12.1511 13.2293 11.705 13.1103 11.705 13.1103Z"
          fill="#272727"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1729 8.19464L10.8063 8.94586L11.1344 8.86869L10.9771 8.11035L10.1729 8.19464Z"
          fill="#D74800"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9955 8.01298L11.0364 9.14238L11.5773 9.00928L11.8076 8.26959L10.9955 8.01298Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4859 9.89941C10.6054 9.89941 10.7022 9.80497 10.7022 9.68848C10.7022 9.57198 10.6054 9.47754 10.4859 9.47754C10.3664 9.47754 10.2695 9.57198 10.2695 9.68848C10.2695 9.80497 10.3664 9.89941 10.4859 9.89941Z"
          fill="#D74800"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8603 8.2246L11.2306 8.9789L11.3635 9.28858L12.083 9.00195L11.8603 8.2246Z"
          fill="#D74800"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3241 13.9334C13.3241 13.9334 14.4319 13.4385 14.4319 12.7464C14.4319 12.0544 12.6331 11.3005 12.6331 11.3005C12.6331 11.3005 11.5751 11.5427 12.052 11.8668C12.5289 12.1908 13.1679 12.3153 13.1679 12.7464C13.1679 13.1776 13.3429 13.5887 12.988 13.5887C12.6331 13.5887 13.3241 13.9334 13.3241 13.9334Z"
          fill="#D74800"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7256 11.1741C11.7256 11.1741 11.3338 11.2429 11.3524 11.3065C11.4038 11.4825 11.9395 11.7116 12.173 11.8702C12.6499 12.1943 13.1021 12.1579 13.4385 11.947C13.7749 11.7361 11.7256 11.1741 11.7256 11.1741Z"
          fill="#FFFDFF"
        />
      </g>
    </svg>
  );
};

export default UG2424Icon;
